var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icp"},[_c('a',{staticClass:"text-color",attrs:{"href":"https://beian.miit.gov.cn","target":"_blank"}},[_vm._v("鲁ICP备19035836号-12")])])
}]

export { render, staticRenderFns }